export const LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED = 'isDesktopFiltersWereApplied';
export const DAYS_THRESHOLD = 7;

interface IFiltersWereAppliedValue {
  date?: number;
  isSecondClick?: boolean;
  isShown?: boolean;
}

/**
 * Значение читается во время рендера страницы: битый JSON не должен ронять выдачу
 */
const parseExisting = (existing: string): IFiltersWereAppliedValue | null => {
  try {
    return JSON.parse(existing);
  } catch {
    return null;
  }
};

//получаем значение
export const getLocalStorageFiltersWereApplied = () => {
  if (typeof window !== 'undefined') {
    try {
      return localStorage.getItem(LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED);
    } catch {
      // localStorage недоступен (запрещено хранилище)
      return null;
    }
  }

  //istanbul ignore next
  return null;
};

//проверяет прошло ли 7 дней
export const getLocalStorageFiltersIsExpired = (existing: string | null) => {
  //istanbul ignore next
  if (typeof window === 'undefined') {
    return false;
  }

  if (!existing) {
    return false;
  }

  const dateFirstClick = Number(parseExisting(existing)?.date);

  const threshold = DAYS_THRESHOLD * 24 * 60 * 60 * 1000;
  const today = Date.now();

  const isExpired = today - dateFirstClick >= threshold;

  return isExpired;
};

//проверяет что фильтры были применены 2 раза
export const getLocalStorageFiltersWereAppliedTwoTimes = (existing: string | null) => {
  //istanbul ignore next
  if (typeof window === 'undefined') {
    return false;
  }

  return existing ? Boolean(parseExisting(existing)?.isSecondClick) : false;
};

//удаляем значение
export const removeLocalStorageFiltersWereApplied = () => {
  //istanbul ignore else
  if (typeof window !== 'undefined') {
    localStorage.removeItem(LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED);
  }
};

//проверяем был ли показан опрос для uxfb
export const getLocalStorageFiltersPollWasShow = (existing: string | null) => {
  //istanbul ignore next
  if (typeof window === 'undefined') {
    return false;
  }

  return existing ? Boolean(parseExisting(existing)?.isShown) : false;
};

//устанавливает показ опроса для uxfb
export const setLocalStorageFiltersPollWasShow = (existing: string | null) => {
  //istanbul ignore next
  if (typeof window === 'undefined') {
    return;
  }

  const parsed = existing && parseExisting(existing);

  if (!parsed) {
    return;
  }

  const value = { ...parsed, isShown: true };

  localStorage.setItem(LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED, JSON.stringify(value));
};
